import { NgModule } from '@angular/core';
import { F3UtilsService } from '@f3/services/utils/utils.service';

@NgModule({
    providers: [
        F3UtilsService
    ]
})
export class F3UtilsModule
{
    /**
     * Constructor
     */
    constructor(private _fuseUtilsService: F3UtilsService)
    {
    }
}
